export default __webpack_public_path__ + "static/media/promo-spectrespecs_03.3d935be7.jpg";